import { ReactElement } from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import styled from 'styled-components'
import { Theme } from 'theme/theme'
import { pages } from 'navigation/pages'

export default function SupportLayout(): ReactElement {
  document.title = 'SUPPORT'

  return (
    <Wrapper>
      <Nav>
        <Title>SUPPORT</Title>
        {/* <NavLink to={pages.connected.support.invoiceQuotationMissing.navigate()}>Missing QUot</NavLink> */}
        <NavLink to={pages.connected.support.companyLastDocs.navigate()}>Artisans Inactifs (+30 jours)</NavLink>
        <NavLink to={pages.connected.support.imageResizer.navigate()}>Logo Resizer</NavLink>
        <Title>SUPPORT - ARTISAN</Title>
        <NavLink to={pages.connected.support.accountSubcriptionDateMissing.navigate()}>
          Check date abonnement
        </NavLink>
        <NavLink to={pages.connected.support.accountResiliationDateMissing.navigate()}>Check date résiliation</NavLink>
        <NavLink to={pages.connected.support.subAccountNotSyncWithBossAccount.navigate()}>Check compte salarié - subscription</NavLink>
        <NavLink to={pages.connected.support.subAccountNotSyncWithBossAccountDemo.navigate()}>Check compte salarié - demo</NavLink>
      </Nav>
      <WrapperContent>
        <Outlet />
      </WrapperContent>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  border-right: solid 1px ${Theme.colors.greyDark};
  padding-right: 15px;
  font-size: 15px;
  gap: 20px;
  a {
    color: ${Theme.colors.blueArtizen};
    font-weight: 700;
    text-decoration: none;
  }

  a.active {
    color: ${Theme.colors.greenArtizen};
  }
`

const Title = styled.span`
  font-size: 20px;
  font-weight: 700;
  border-bottom: 2px solid ${Theme.colors.blueArtizen};
  color: ${Theme.colors.blueArtizen};
`

const WrapperContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 15px;
`
